function getRouteForError(error) {
  if (error && error.route) {
    return `/error/${error.route}`;
  }
  if (error && error.response) {
    switch (error.response.status) {
      case 404:
        return '/setup';
      default:
        return '/error';
    }
  }
}

const routeError = (history, options) => err => {
  const queryString = options ? `?${options}` : '';
  const baseRoute = getRouteForError(err);
  const route = `${baseRoute}${queryString}`;
  history.push(route);
};

export default routeError;
